import { connect } from 'react-redux';

import { scrollToTop } from '@scandipwa/scandipwa/src/util/Browser';

import {
    FooterContainer as SourceFooterContainer,
    mapDispatchToProps,
    mapStateToProps,
} from 'SourceComponent/Footer/Footer.container';

import Footer from './Footer.component';
import React from "react";

export {
    mapStateToProps,
    mapDispatchToProps,
};

/** @namespace BluehiraPwa/Component/Footer/Container */
export class FooterContainer extends SourceFooterContainer {
    static defaultProps = {
        copyright: '',
        isVisibleOnMobile: false,
    };

    containerFunctions = {
        onItemClick: this.onItemClick.bind(this),
    };

    containerProps() {
        const {
            copyright,
            isVisibleOnMobile,
            device,
            newsletterActive,
        } = this.props;

        return {
            copyright,
            isVisibleOnMobile,
            device,
            newsletterActive,
        };
    }

    onItemClick() {
        scrollToTop();
    }

    render() {
        return (
            <Footer
                {...this.containerProps()}
                {...this.containerFunctions}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
